@if (showNav) {
  <app-nav></app-nav>
}
@if (showNav) {
  <app-announcement></app-announcement>
}
<div [class.page-container]="showNav">
  <router-outlet (activate)="onActivate()"></router-outlet>
</div>
